export const SuggestedActivitiesConstants = {
  physicalExercisesCategoryId: 'Aq00hErqB1yWA8vPv81m',
  meditationAndRelaxationCategoryId: 'y4EAWJueQJCYkkMWWqRD',
  brainExerciseCategoryId: 'NEM6H1Rga8z62Q9kg498',
  recipesCategoryId: 'fiadZcWnjPC5MUCA4q6c',
  voiceExerciseCategoryId: '3TFbRIqkQyAPS1lhVQFy',
  alternativeTherapiesCategoryId: 'DGT06eR8HTiWnFSvYg2x',
} as const

export type RecommendedActivitiesSource = 'suggested' | 'recipe'

export interface RecommendedActivitiesCategory {
  key:
    | 'physical-exercises'
    | 'meditation-relaxation'
    | 'brain-exercises'
    | 'nutrition'
    | 'voice-exercises'
    | 'alternative-therapies'
  title: string
  source: RecommendedActivitiesSource
  categoryIds: string[]
}

export const RECOMMENDED_ACTIVITIES_CATEGORIES: RecommendedActivitiesCategory[] = [
  {
    key: 'physical-exercises',
    title: 'Physical exercises',
    source: 'suggested',
    categoryIds: [
      SuggestedActivitiesConstants.physicalExercisesCategoryId,
      'Aq00hErqB1yWA8vPv81m',
    ],
  },
  {
    key: 'meditation-relaxation',
    title: 'Meditation & relaxation',
    source: 'suggested',
    categoryIds: [
      SuggestedActivitiesConstants.meditationAndRelaxationCategoryId,
      'y4EAWJueQJCYkkMWWqRD',
    ],
  },
  {
    key: 'brain-exercises',
    title: 'Brain exercises',
    source: 'suggested',
    categoryIds: [
      SuggestedActivitiesConstants.brainExerciseCategoryId,
      'NEM6H1Rga8z62Q9kg498',
    ],
  },
  {
    key: 'nutrition',
    title: 'Nutrition',
    source: 'recipe',
    categoryIds: [
      SuggestedActivitiesConstants.recipesCategoryId,
      'fiadZcWnjPC5MUCA4q6c',
    ],
  },
  {
    key: 'voice-exercises',
    title: 'Voice exercises',
    source: 'suggested',
    categoryIds: [
      SuggestedActivitiesConstants.voiceExerciseCategoryId,
      '3TFbRIqkQyAPS1lhVQFy',
    ],
  },
  {
    key: 'alternative-therapies',
    title: 'Alternative therapies',
    source: 'suggested',
    categoryIds: [
      SuggestedActivitiesConstants.alternativeTherapiesCategoryId,
      'DGT06eR8HTiWnFSvYg2x',
    ],
  },
]
